import { Component, OnInit } from '@angular/core';
import { NewsPromotionItem, NewsPromotionService } from '../../services/news-promotion.service';

@Component({
  selector: 'app-news-promotions',
  templateUrl: './news-promotions.component.html',
  styleUrls: ['./news-promotions.component.css']
})
export class NewsPromotionsComponent implements OnInit {
  featuredItem: NewsPromotionItem | null = null;
  promotionsItems: NewsPromotionItem[] = [];
  newsItems: NewsPromotionItem[] = [];

  isLoading = false;
  errorMessage = '';
  emptyMessage = 'No records found';

  constructor(private newsPromotionService: NewsPromotionService) { }

  ngOnInit(): void {
    this.loadNewsPromotions();
  }

  retryLoad(): void {
    this.loadNewsPromotions();
  }

  private loadNewsPromotions(): void {
    this.isLoading = true;
    this.errorMessage = '';

    this.newsPromotionService.getAll(1, 10).subscribe({
      next: (response) => {
        const allItems = response.items || [];
        const promotions = allItems.filter((item) => item.type === 'PROMOTION');
        const news = allItems.filter((item) => item.type === 'NEWS');

        this.featuredItem = promotions[0] || news[0] || null;
        this.promotionsItems = promotions.filter((item) => item.id !== this.featuredItem?.id);
        this.newsItems = news;
        this.emptyMessage = response.message || 'No records found';
        this.isLoading = false;
      },
      error: () => {
        this.featuredItem = null;
        this.promotionsItems = [];
        this.newsItems = [];
        this.errorMessage = 'Unable to load news and promotions right now. Please try again later.';
        this.isLoading = false;
      }
    });
  }
}
